export const TextureEditorSettings = {
    PhysicalCacheSizeInBytes: 2 * 1024 * 1024 * 1024, // 2GB physical cache size
    VirtualCacheSizeInBytes: 256 * 1024 * 1024, // 256MB virtual cache size
    NumVirtualPages: 4096, // 4096 pages per atlas × 4 atlases = 16384 total; each page is 256×256 float32 ≈ 256KB; total ≈ 4GB
    MaxNumAtlases: 4,
    MaxPixelsPerUpload: 2 * 1024 * 1024, // 2M pixels per strip for chunked GPU uploads
    MaxWriteRegionPixels: 4096 * 4096, // max pixels per writeRegion / subSampleRegion call to keep temporary GPU allocations bounded

    // Legacy trace toggles - kept for UI compatibility, but logging now uses CmLogger
    // TODO: Connect these toggles to the LoggerFactory to enable/disable debug logging at runtime
    EnableFullTrace: false,
    EnableAllocTrace: false,

    EnableDebug: false,
    InterpolateStretchBlit: true,

    ShowTiles: false,
    MinMipLevel: 0,

    DefaultMeasurementUnit: "cm" as const,
    PageDescriptorWarnLimit: 500, // this will be overwritten by the tiling-canvas component to make it dependent on the size of the canvas
    RegionPixelsWarnLimit: 1000000000,

    PixelSize: 1,

    EnableTests: false,
}
